/**
 * Helper module for parsing/encoding URLs
 * @module
 */
var _ = require('optimizely-client-fn');

/**
 * @typedef {Object} Location - subset of data object for Location-like interface - related links
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils
 * https://html.spec.whatwg.org/multipage/browsers.html#the-location-interface
 *
 * @property {string} hash
 * @property {string} href
 * @property {string} search
 */

/**
 * Parses given URL string into browser-Location-like object
 * @param url
 * @returns {module:core/utils/location~Location}
 */
exports.create = function parse(url): import('core/utils/location').Location {
  if(_.isEmpty(url)) {
    return null;
  }
  var link = document.createElement('a');
  link.href = url;
  return link;
};
